module.exports = "/assets/9009a5e3e73884d0deeb65b5ddd2fe79.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/JM.png
// module id = 1515
// module chunks = 0